module.exports = __webpack_public_path__ + "static/img/logo_black.d091153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo_black.png
// module id = LhHd
// module chunks = 13